import { useEffect } from 'react'
import { Path, UseFormReturn } from 'react-hook-form'

import { FieldsErrors } from 'interfaces/errors'

export function useServerErrorsApplyToForm<
  E extends FieldsErrors<string>,
  F extends Record<keyof E, unknown>,
> (
  formContext: UseFormReturn<F>,
  formFieldsErrorsOrNull: E | null,
): void {
  const { setError } = formContext
  useEffect(() => {
    if (!formFieldsErrorsOrNull) {
      return
    }
    Object.keys(formFieldsErrorsOrNull).forEach((formFieldName: Path<F>) => {
      const firstErrorMessageForField = formFieldsErrorsOrNull?.[formFieldName]?.[0]
      setError(formFieldName, {
        type: 'manual',
        message: firstErrorMessageForField,
      })
    })
  }, [setError, formFieldsErrorsOrNull])
}
